import { useState } from 'react';
import { Button, Modal, Form } from "react-bootstrap";
import './resourcerequest.css';

const Resourcerequest: React.FC = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <div className="common_card">
                <div className="top">
                    <div className="top_bar_tittle">
                        <h2>Pending Participant Requests</h2>
                        <p>Review incoming resource and tier bump requests. Add notes, approve, or deny with routing.</p>
                    </div>
                </div>
                <div className="resource_request_grid">
                    <div className="resource_request_card">
                        <div className="resource_request_left">
                            <div className="resource_request_left_flx">
                                <div className="resource_request_left_txt">
                                    <h3>Jane Doe - Resource</h3>
                                    <p>Transportation • May 12, 2025</p>
                                </div>
                                <div className="resource_request_left_txt">
                                    <h3>Needs recurring transport to clinic</h3>
                                    <p>Urgency: High</p>
                                </div>
                            </div>
                        </div>
                        <div className="resource_request_right">
                            <Button variant="primary" className="btn_sm" onClick={handleShow}>Resource</Button>
                        </div>
                    </div>
                    <div className="resource_request_card">
                        <div className="resource_request_left">
                            <div className="resource_request_left_flx">
                                <div className="resource_request_left_txt">
                                    <h3>Michael Johnson - Bump Request</h3>
                                    <p>Tier Increase • May 10, 2025</p>
                                </div>
                                <div className="resource_request_left_txt">
                                    <h3>Recently hospitalized twice and needs more hours</h3>
                                    <p>Urgency: Medium</p>
                                </div>
                            </div>
                        </div>
                        <div className="resource_request_right">
                            <Button variant="primary" className="btn_sm" onClick={handleShow}>Bump Request</Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Resource Request popup */}
            <Modal show={show} onHide={handleClose} centered className="custom_popup with_close_icon resource_Request_popup">
                <Modal.Header closeButton>
                    <Modal.Title>Resource Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="from_transpo">
                        <h2>From <span>John Doe</span> - Transportation</h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="stats mby_16">
                                <h3>Submitted</h3>
                                <p>May 12,2025</p>
                            </div>
                        </div>
                        <div className="col-md-6 mby_16">
                            <div className="stats">
                                <h3>Urgency</h3>
                                <p>High</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="stats mby_16">
                                <h3>Note</h3>
                                <p>Needs recurring transport to clinic</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="stats mby_16">
                                <h3>Current Tier</h3>
                                <p>Tier 1</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="stats mby_16">
                                <h3>Current Services</h3>
                                <p>In-Home Care, Meal Delivery</p>
                            </div>
                        </div>
                    </div>
                    <Form.Group className="custom_input_flled mb-0" controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Support Coordinator Notes </Form.Label>
                        <Form.Control as="textarea" rows={3} placeholder='Enter description'/>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Deny & Send to Supervisor
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Approve & Initiate Task
                    </Button>
                </Modal.Footer>
            </Modal>

             {/* Resource Request popup */}
            {/* <Modal show={show} onHide={handleClose} centered className="custom_popup with_close_icon resource_Request_popup">
                <Modal.Header closeButton>
                    <Modal.Title>Resource Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="from_transpo">
                        <h2>From <span>Michael Johnson</span> - Tier Increase</h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="stats mby_16">
                                <h3>Submitted</h3>
                                <p>May 12,2025</p>
                            </div>
                        </div>
                        <div className="col-md-6 mby_16">
                            <div className="stats">
                                <h3>Urgency</h3>
                                <p>Medium</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="stats mby_16">
                                <h3>Note</h3>
                                <p>Recently hospitalized twice and need more hours</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="stats mby_16">
                                <h3>Current Tier</h3>
                                <p>CC, Support, ROW, NOW</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="stats mby_16">
                                <h3>Relevant Incidents</h3>
                                <ul className="stats_list relevant_incidents_list">
                                    <li>ER Visit - April 20</li>
                                    <li>Hospitalized - May 1</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <Form.Group className="custom_input_flled mb-0" controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Support Coordinator Notes </Form.Label>
                        <Form.Control as="textarea" rows={3} placeholder='Enter description'/>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Deny & Send to Supervisor
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Approve & Initiate Task
                    </Button>
                </Modal.Footer>
            </Modal> */}
        </>
    );
};

export default Resourcerequest;